<template>
  <div class="project-status">
    <v-form
      ref="changeProjectStatusForm"
      v-model="isFormValid"
      @submit.prevent="submitForm"
    >
      <label class="input-label mb-2 ml-2">Status</label>
      <v-select
        v-model="selectedStatus"
        v-bind="props.select"
        :rules="[rules.required]"
        :hide-details="false"
        :items="availableStatuses"
        item-text="status"
        item-value="status"
        height="40"
        placeholder="Wybierz status"
      />
      <v-btn
        class="custom-submit-button mt-2"
        color="primary"
        type="submit"
        :loading="isProcessing"
      >
        Potwierdź zmianę
      </v-btn>
    </v-form>
  </div>
</template>

<script>
import { mapState, mapActions } from 'vuex';
import props from '@/helpers/componentsProps';
import rules from '@/helpers/validators';

export default {
  props: {
    id: {
      type: [Number, String],
      required: true,
    },
    step: {
      type: String,
      required: false,
    },
  },

  data() {
    return {
      props,
      rules,
      isFormValid: true,
      selectedStatus: '',
    };
  },

  computed: {
    ...mapState('filters', ['filtersOptions']),
    ...mapState('project', ['isProcessing', 'project']),

    availableStatuses() {
      const { projectStatuses, projectStatusesForEdit } = this.filtersOptions;
      const allStatuses = this.project.printCoordination ? projectStatuses : projectStatusesForEdit;
      if (!this.step) return allStatuses;
      return allStatuses.filter((status) => status.step === Number(this.step));
    },
  },

  methods: {
    ...mapActions('project', ['changeProjectStatus']),

    submitForm() {
      this.$refs.changeProjectStatusForm.validate();

      if (this.isFormValid) {
        this.changeProjectStatus(this.selectedStatus);
      }
    },
  },
};
</script>
